import React from 'react';
import { Table } from 'semantic-ui-react';
import { firstErrorMessage } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import TableHeader from '@/components/table/TableHeader';
import DatasetsTableColumns from '../containers/DatasetsTableColumns';

const DatasetsTableHeader = ({
  category,
  children,
  columns,
  datasets,
  hideColumns,
  loaderButton,
  readErrors,
  readStatus,
}) => (
  <Table.Header fullWidth>
    <TableHeader
      isLoading={readStatus === states.PENDING}
      error={firstErrorMessage(readErrors)}
      numberOfColumns={columns.length}
      loaderButton={loaderButton}
    >
      {children}
    </TableHeader>
    {!hideColumns && <DatasetsTableColumns category={category} items={datasets} columns={columns} />}
  </Table.Header>
);

export default DatasetsTableHeader;
